import api from 'api';

const profileUrl = '/api/forget-me/event/:id/:eventId';

export default {
    forgetMe: (userid, eventId) => api.get({path: profileUrl.replace(':id', userid).replace(':eventId', eventId)})
}